"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.migration_17_0_0 = void 0;
const echain_shared_articles_1 = require("@igus/echain-shared-articles");
/**
 * Migrate to 17.0.0
 *
 * The CustomVerpackung has been removed in favor of Karton.
 *
 *  typ: custom
 *
 *  =>
 *
 *  typ: karton
 */
const migration_17_0_0 = (json) => {
    if (json.Verpackungen) {
        for (const verpackung of json.Verpackungen) {
            if (verpackung.Typ === 'custom') {
                verpackung.Typ = echain_shared_articles_1.VerpackungType.karton;
            }
        }
    }
    return json;
};
exports.migration_17_0_0 = migration_17_0_0;
//# sourceMappingURL=migration_17_0_0.js.map